<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">默认值</nz-form-label>
  <nz-form-control>
    <input
      nz-input
      [name]="config.name"
      [placeholder]="config.placeholder"
      [(ngModel)]="config.value"
      [required]="config.required"
      (ngModelChange)="onChange($event)"
    />
  </nz-form-control>
</nz-form-item>

<!-- 固定值 -->
<nz-form-item>
  <nz-form-label [nzSpan]="6">固定值</nz-form-label>
  <nz-form-control>
    <input nz-input name="fixedValue" [(ngModel)]="config.fixedValue" />
  </nz-form-control>
</nz-form-item>
